import { useState } from "react";
import { Card, Icon } from "@mui/material";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import BasicTable from "ui-components/tables/BasicTable";
import { ListLayout } from "ui-components/Layout";
import { Error } from "ui-components/Alert";
import { useCustomerValue } from "providers/CustomerContext";
import { getStockTransferList } from "services/data.inventory.service";
import { TableCard } from "ui-components/Layout";
import { useTeamValue } from "providers/TeamContext";
import InterDivisionStockTransferDrawer from "./components/InterDivisionStockTransferDrawer";
import { getInterDivisionStockTransferList } from "services/data.inventory.service";

function InterDivisionStockTransferList() {
  const {permissions, allowAll} = useTeamValue();
  const { customerCode } = useCustomerValue();
  const navigate = useNavigate();
  const [alert, setAlert] = useState(null);
  const [dialog, setDialog] = useState(null);
  const [data, setData] = useState([]);
  const onError = (data) => setAlert(<Error data={data} onChange={setAlert} />);

  const addPermission = allowAll || (Boolean(permissions["Inter Division Stock Transfer"]) && permissions["Inter Division Stock Transfer"].findIndex(b => b==="new") !== -1);

  useQuery({
    queryKey: ["stock-transfer-list", customerCode],
    queryFn: () => getInterDivisionStockTransferList({ customerCode }),
    onSuccess: (data) => {
      setData(data.data.data);
    },
    onError,
  });

  const onNew = () => navigate("/inventory/inter-division-stock-transfer/add");

  const [sTransferRequest, setSTransferRequest] = useState(null);
  const [open, setOpen] = useState(false);
  const drawerProp = { open, setOpen, sTransferRequest, setSTransferRequest };
  const columns = [
    {
      header: "Stock Transfer No",
      accessorKey: "stockTransferNo",
      cell: ({ row }) => {
        const { stockTransferNo } = row.original;
        return (
          <span
            style={{ color: "#1A73E8", cursor: "pointer", textDecoration: "underline" }}
            onClick={() => {
              setOpen(true);
              setSTransferRequest({ stockTransferNo, customerCode });
            }}
          >
            {stockTransferNo}
          </span>
        );
      },
    },
    { header: "From Warehouse Code", accessorKey: "fromWarehouseCode" },
    { header: "Reason", accessorKey: "reason" },
    { header: "Created Date", accessorKey: "createdOn" },
    { header: "Created By", accessorKey: "createdBy" },
  ];

  return (
    <ListLayout>
      <InterDivisionStockTransferDrawer {...drawerProp} />
      {alert}
      {dialog}
      <TableCard sx={{my:3}}>
        <MDBox display="flex" justifyContent="space-between" margin="10px">
          <MDButton variant="gradient" color="info" disabled={!addPermission} onClick={onNew}>
            <Icon>add</Icon>&nbsp;inter-division&nbsp;stock&nbsp;transfer
          </MDButton>
        </MDBox>
        <BasicTable columns={columns} data={data} />
      </TableCard>
    </ListLayout>
  );
}

export default InterDivisionStockTransferList;
